(() => {
  const isMobile = () =>
    window.matchMedia && window.matchMedia("(max-width: 1025px)").matches;

  const isDebug = () => {
    try {
      return (
        window.COSMO_MNAV_DEBUG === true ||
        window.COSMO_MNAV_DEBUG === "1" ||
        localStorage.getItem("COSMO_MNAV_DEBUG") === "1"
      );
    } catch (_) {
      return false;
    }
  };

  const dlog = (...args) => {
    if (!isDebug()) return;
    // eslint-disable-next-line no-console
    console.log("[cosmo-mnav]", ...args);
  };

  const panelStack = new WeakMap();
  const movedFrom = new WeakMap(); // panel -> original parent element
  let uid = 0;
  const nextId = () => {
    uid += 1;
    return `cosmo-mnav-panel-${uid}`;
  };

  const getStack = (root) => {
    if (!panelStack.has(root)) panelStack.set(root, []);
    return panelStack.get(root);
  };

  const getRootPanel = (root) =>
    root?.querySelector?.('[data-mnav-panel="root"]') ||
    root?.querySelector?.("ul.cosmo-mnav__panel");

  const activatePanel = (root, panel) => {
    const panelsWrap = root?.querySelector?.("[data-mnav-panels]");
    if (!panelsWrap || !panel) return;
    panelsWrap.querySelectorAll(".cosmo-mnav__panel").forEach((p) => {
      p.classList.remove("is-active");
    });
    panel.classList.add("is-active");
  };

  const ensurePanelIsTopLevel = (root, panel) => {
    const panelsWrap = root?.querySelector?.("[data-mnav-panels]");
    if (!panelsWrap || !panel) return;
    if (panel.parentElement === panelsWrap) return;
    if (!movedFrom.has(panel)) movedFrom.set(panel, panel.parentElement);
    panelsWrap.appendChild(panel);
    panel.dataset.cosmoMnavMoved = "1";
  };

  const ensurePanelId = (panel) => {
    if (!panel) return null;
    if (!panel.id) panel.id = nextId();
    return panel.id;
  };

  const findPanelForTrigger = (root, openLink) => {
    if (!root || !openLink) return null;
    const li = openLink.closest("li");
    if (!li) return null;

    // 1) First try: nested panel under this <li> (original markup)
    for (let i = 0; i < li.children.length; i++) {
      const ch = li.children[i];
      if (
        ch &&
        ch.tagName === "UL" &&
        ch.classList.contains("cosmo-mnav__panel") &&
        ch.hasAttribute("data-mnav-panel")
      ) {
        return ch;
      }
    }

    // 2) Fallback: panel was moved to top-level; we stored its id on the trigger
    const targetId = openLink.getAttribute("data-mnav-target");
    if (!targetId) return null;
    return document.getElementById(targetId);
  };

  const resetNav = (root) => {
    if (!root) return;
    getStack(root).length = 0;
    const cta = root.querySelector(".cosmo-mnav__cta");
    if (cta) cta.hidden = false;
    setChildMode(root, false);
    const rootPanel = getRootPanel(root);
    if (rootPanel) activatePanel(root, rootPanel);
    const subbar = root.querySelector("[data-mnav-subbar]");
    if (subbar) subbar.hidden = true;
  };

  const bindDrawerAriaListener = () => {
    const drawer = document.querySelector("#t4s-menu-drawer");
    if (!drawer || drawer.dataset.cosmoMnavAriaBound === "1") return;
    drawer.dataset.cosmoMnavAriaBound = "1";

    const sync = () => {
      const open = drawer.getAttribute("aria-hidden") === "false";
      document.documentElement.classList.toggle("cosmo-mnav--open", open);
      const root = drawer.querySelector("[data-cosmo-mnav]");
      if (open) {
        // Detect when the theme is rendering the *old* mobile menu instead of our panel markup.
        dlog("drawer open", {
          hasCosmoRoot: !!root,
          drawerChildren: drawer.children ? drawer.children.length : null,
        });
        if (!root) {
          // eslint-disable-next-line no-console
          console.warn(
            "[cosmo-mnav] Drawer opened but `[data-cosmo-mnav]` not found. This means the old menu HTML is being rendered/loaded instead of `sections/mb_nav.liquid`."
          );
        }
      } else {
        resetNav(root);
      }
    };

    sync();
    new MutationObserver(sync).observe(drawer, {
      attributes: true,
      attributeFilter: ["aria-hidden"],
    });
  };

  const setChildMode = (root, isChild) => {
    if (!root) return;
    root.classList.toggle("cosmo-mnav--child", !!isChild);
    document.documentElement.classList.toggle("cosmo-mnav--child", !!isChild);
  };

  const isDrawerOpen = () => {
    const drawer = document.querySelector("#t4s-menu-drawer");
    return !!drawer && drawer.getAttribute("aria-hidden") === "false";
  };

  const closeDrawer = () => {
    const closeBtn =
      document.querySelector(".t4s-drawer-menu__close[data-drawer-close]") ||
      document.querySelector("[data-drawer-close]");
    if (closeBtn) closeBtn.click();
  };

  const handleHeaderIconsWhileMenuOpen = (e) => {
    // Only needed when the menu drawer is open on mobile root screen.
    if (!isMobile() || !isDrawerOpen()) return false;
    if (document.documentElement.classList.contains("cosmo-mnav--child"))
      return false;

    const header = e.target.closest("#shopify-section-header-inline");
    if (!header) return false;

    

    const cartLink = e.target.closest('a[data-drawer-options*="#t4s-mini_cart"]');
    if (cartLink) {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
      // Open cart drawer after menu closes.
      setTimeout(() => {
        cartLink.click();
      }, 120);
      return true;
    }

    const parentalLink = e.target.closest(".parental-portal-btn-area a");
    if (parentalLink && parentalLink.href) {
      e.preventDefault();
      e.stopPropagation();
      const href = parentalLink.href;
      closeDrawer();
      setTimeout(() => {
        window.location.href = href;
      }, 120);
      return true;
    }

    return false;
  };

  const onDocActivate = (e) => {
    
    // Prevent navigation on the menu toggle for mobile/tablet, but allow theme handler.
    const menuToggle = e.target.closest(".t4s-push-menu-btn[data-menu-drawer]");
    if (menuToggle) {
      e.preventDefault();
      // If drawer is already open, close it (X behavior).
      if (isDrawerOpen()) {
        e.stopPropagation();
        closeDrawer();
        return;
      }
      // If drawer is closed, do not stop propagation so theme can open it.
    }

    if (handleHeaderIconsWhileMenuOpen(e)) return;
    const root = e.target.closest("#t4s-menu-drawer [data-cosmo-mnav]");
    if (!root) {
      if (isDebug() && e.target.closest("#t4s-menu-drawer")) {
        dlog("event inside drawer but no cosmo root", {
          type: e.type,
          target: e.target && e.target.tagName,
        });
      }
      return;
    }

    const openLink = e.target.closest("[data-mnav-open]");
    if (openLink && root.contains(openLink)) {
      dlog("openLink", { type: e.type, text: openLink.textContent?.trim?.() });
      const panel = findPanelForTrigger(root, openLink);
      if (!panel) return;
      e.preventDefault();
      e.stopPropagation();
      const panelsWrap = root.querySelector("[data-mnav-panels]");
      if (!panelsWrap) {
        dlog("missing [data-mnav-panels] wrapper");
        return;
      }

      // Ensure we can re-open this panel even after it is moved.
      const panelId = ensurePanelId(panel);
      if (panelId) openLink.setAttribute("data-mnav-target", panelId);

      const stack = getStack(root);
      const current =
        panelsWrap.querySelector(".cosmo-mnav__panel.is-active") ||
        getRootPanel(root);
      if (current) stack.push(current);

      ensurePanelIsTopLevel(root, panel);
      dlog("switch to child panel", { stackDepth: stack.length });
      activatePanel(root, panel);
      panel.scrollTop = 0;
      const subbar = root.querySelector("[data-mnav-subbar]");
      if (subbar) subbar.hidden = false;
      setChildMode(root, true);
      return;
    }

    const backBtn = e.target.closest("[data-mnav-back]");
    if (backBtn && root.contains(backBtn)) {
      dlog("back", { type: e.type });
      e.preventDefault();
      e.stopPropagation();
      const stack = getStack(root);
      const prev = stack.pop();
      dlog("back to previous", { stackDepth: stack.length, hadPrev: !!prev });
      if (!prev) return;
      activatePanel(root, prev);
      prev.scrollTop = 0;
      const subbar = root.querySelector("[data-mnav-subbar]");
      if (subbar) subbar.hidden = stack.length === 0;
      setChildMode(root, stack.length > 0);
    }
  };

  const boot = () => {
    bindDrawerAriaListener();
  };

  // Some theme scripts swallow/cancel "click" on mobile; listen to pointerup too.
  document.addEventListener("click", onDocActivate, true);
  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

